import { render } from "./OrderDepartureCustomsForm.vue?vue&type=template&id=cd55ec22&scoped=true&ts=true"
import script from "./OrderDepartureCustomsForm.vue?vue&type=script&lang=ts"
export * from "./OrderDepartureCustomsForm.vue?vue&type=script&lang=ts"

import "./OrderDepartureCustomsForm.vue?vue&type=style&index=0&id=cd55ec22&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd55ec22"]])

export default __exports__